import { getUseCaseHref } from "../how-inito-works/_utils/use-case-content";

export type DropdownItem = { label: string; href: string };
export type NavItem = {
  label: string;
  href: string;
  hasDropdown?: boolean;
  dropdownItems?: DropdownItem[];
  dropdownClassName?: string;
};

export const USE_CASES_ITEMS: DropdownItem[] = [
  { label: "PCOS", href: getUseCaseHref("pcos") },
  { label: "Trying after 35", href: getUseCaseHref("trying-after-35") },
  { label: "After miscarriage", href: getUseCaseHref("after-miscarriage") },
  { label: "Irregular cycle", href: getUseCaseHref("irregular-cycle") },
  { label: "Before IVF", href: getUseCaseHref("before-ivf") },
];

export const LEARN_ITEMS: DropdownItem[] = [
  { label: "Blog", href: "https://blog.inito.com" },
  { label: "Ovulation Calculator", href: "/blog/ovulation-calculator" },
];

export const DESKTOP_NAV_ITEMS: NavItem[] = [
  {
    label: "How Inito Works",
    href: "#",
    hasDropdown: true,
    dropdownItems: USE_CASES_ITEMS,
    dropdownClassName: "w-[246px]",
  },
  { label: "Learn", href: "#", hasDropdown: true, dropdownItems: LEARN_ITEMS },
  { label: "FAQs", href: "/faqs" },
];

export const MOBILE_NAV_ITEMS: NavItem[] = [
  {
    label: "How Inito Works",
    href: "#",
    hasDropdown: true,
    dropdownItems: USE_CASES_ITEMS,
  },
  { label: "Learn", href: "#", hasDropdown: true, dropdownItems: LEARN_ITEMS },
  { label: "FAQs", href: "/faqs" },
];

export const CAREERS_NAV_ITEM: NavItem = {
  label: "Careers",
  href: "/careers",
};
